import emailjs from '@emailjs/browser';

export const sendEmail = async (subject: string, emailTemplate: any) => {
	const emailInfo = {
		from_name: 'TARCian Alumni Association',
		from_email: 'admin@tarcalumni.my',
		title: subject,
		message: emailTemplate,
	};

	await emailjs.send('service_31lgz0m', 'template_i5xjsnn', emailInfo, 'He_zbVQCn1G-b8E04');
};
